function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/*
  Under the hood, calls React Toastify's toast(), publishes and subscribes to
  one a rendered toasts in ToastContainer.
*/

import React from 'react';
import { toast as toastifyToast } from 'react-toastify';
import CheckCircle from "../../../icons/CheckCircle.js";
import Information from "../../../icons/Information.js";
import WarningTriangle from "../../../icons/WarningTriangle.js";
import ToastIcon from "./subcomponents/Icon.js";
import InnerLayout from "./subcomponents/InnerLayout.js";
/**
 * This is a function, not a React component.
 *
 * Use dot notation to get semantic styling (toast.success() and toast.error()).
 * Otherwise, toast will use neutral default styling with an info icon instead.
 *
 * @param {ToastContent} content React.ReactNode - The message of a toast. Avoid
 * inline CTAs if possible.
 * @param {CTA} cta? React.ReactNode - Use to pass an optional button or link
 * with a callback which will be automatically styled and positioned.
 * @param {ToastOptions} toastifyOptions? ToastOptions - Properties will
 * override our individual defaults.
 * https://fkhadra.github.io/react-toastify/api/toast
 *
 * @returns void
 */
export var toast = (content, cta, toastifyOptions) => {
  toastifyToast( /*#__PURE__*/React.createElement(InnerLayout, {
    content: content,
    cta: cta
  }), _objectSpread({
    icon: /*#__PURE__*/React.createElement(ToastIcon, {
      component: Information
    })
  }, toastifyOptions));
};
export var success = (content, cta, toastifyOptions) => {
  toastifyToast.success( /*#__PURE__*/React.createElement(InnerLayout, {
    content: content,
    cta: cta
  }), _objectSpread({
    icon: /*#__PURE__*/React.createElement(ToastIcon, {
      component: CheckCircle
    })
  }, toastifyOptions));
};
export var error = (content, cta, toastifyOptions) => {
  toastifyToast.error( /*#__PURE__*/React.createElement(InnerLayout, {
    content: content,
    cta: cta
  }), _objectSpread({
    icon: /*#__PURE__*/React.createElement(ToastIcon, {
      component: WarningTriangle
    })
  }, toastifyOptions));
};

/**
 * Careful using this lil guy. It does not pass on a callback for a toast
 * instance, but rather ANY toast rendered. If you do need it, ensure that you
 * only invoke it once per unique callback, including rerendering.
 *
 */
export var globalToastsOnChange = toastifyToast.onChange;
toast.default = toast;
toast.success = success;
toast.error = error;